import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/esm/Button';

function VehicleCard({
  vehicle,
  onDeleteVehicle,
  batchSelectedVehicles,
  setBatchSelectedVehicles,
}) {
  return (
    <Card>
      <Card.Body>
        <div className='d-flex gap-2 align-items-center justify-content-between'>
          <div className='d-flex gap-2 align-items-center'>
            {vehicle.racingNumbers?.map((rn, index) => (
              <span key={index} className='bg-secondary-black text-white p-1'>
                {rn}
              </span>
            ))}
          </div>
          <div className='d-flex align-items-center gap-1'>
            <span className='me-1 text-secondary'>Besiktning</span>
            {vehicle.translatedInspectionStatus === 'Godkänd' ? (
              <span className='bg-success p-1'>
                {vehicle.translatedInspectionStatus}
              </span>
            ) : vehicle.translatedInspectionStatus === 'Åtgärd' ? (
              <span className='bg-danger p-1'>
                {vehicle.translatedInspectionStatus}
              </span>
            ) : (
              <span className='p-1'>{vehicle.translatedInspectionStatus}</span>
            )}
          </div>
        </div>
        <Card.Footer className='mt-2' style={{ paddingRight: 0 }}>
          <div className='d-flex justify-content-between'>
            <div className='d-flex gap-2 align-items-center'>
              <input
                id={vehicle.vehicleId}
                type='checkbox'
                checked={batchSelectedVehicles.some(
                  (v) => v.vehicleId === vehicle.vehicleId
                )}
                onChange={() => {
                  let newArr = [...batchSelectedVehicles];

                  if (newArr.some((v) => v.vehicleId === vehicle.vehicleId)) {
                    newArr = newArr.filter(
                      (v) => v.vehicleId !== vehicle.vehicleId
                    );
                  } else {
                    newArr = [...newArr, vehicle];
                  }

                  setBatchSelectedVehicles(newArr);
                }}
              />
              <label htmlFor={vehicle.vehicleId}>Markera</label>
            </div>
            <Button
              variant='outline-primary'
              className='d-flex align-items-center justify-conent-between'
              onClick={() => onDeleteVehicle(vehicle.vehicleId)}
            >
              <span className='material-symbols-outlined'>delete</span>
              Ta bort
            </Button>
          </div>
        </Card.Footer>
      </Card.Body>
    </Card>
  );
}

export default VehicleCard;
